<template>
  <el-dialog
    class="dialog-container"
    :visible.sync="dialogVisible"
    append-to-body
    destroy-on-close
  >
    <div slot="title" class="header-title">
      <img src="@/assets/image/newIssue.png" alt="" />
      <span>{{ dialogTitle }}</span>
    </div>
    <div class="importContainer">
      <!-- <div class="filter-container"> -->
      <drag-upload
        ref="uploadFile"
        :accessoryList.sync="fileList"
        :httpRequest="action"
        :tipStatus="false"
        :accept="acceptType"
        :uploadTips="uploadTip"
      />
      <div class="flex_default_center">
        <el-button
          @click="handelConfirm"
          class="primary-btn lang-but"
          type="primary"
          >{{ $t("home.confirm") }}</el-button
        >
        <el-button
          class="primary-btn lang-but"
          plain
          @click="dialogVisible = false"
          >{{ $t("seek.cancel") }}</el-button
        >
      </div>
      <!-- </div> -->
    </div>
  </el-dialog>
</template>
<script>
import { getVinSaveFile } from "@/api/vehicleUpgrade";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "", // 弹框标题
      acceptType: "", // 附件上传类型
      uploadTip: "", //附件上传提示
      fileList: [],
      action: "",
      vinId: "",
    };
  },
  methods: {
    // 初始化
    async init(data, title, type, tips, uploadPath) {
      this.dialogVisible = true;
      this.dialogTitle = title;
      this.acceptType = type;
      this.uploadTip = tips;
      this.vinId = data.id;
      this.fileList = data.files;
      this.action = uploadPath;
    },
    // 提交
    handelConfirm() {
      var listId = [];
      if (this.fileList) {
        listId = this.fileList.map((item) => item?.uploadFileId || item?.id);
      }
      getVinSaveFile({
        data: {
          vinId: this.vinId,
          fileIds: listId,
        },
      }).then((res) => {
        if (res.status == 0) {
          this.$DonMessage.success(this.$t("message.czcg"));
          this.$emit("success");
          this.dialogVisible = false;
        } else {
          this.$DonMessage.error(res.data.message);
        }
      });
    },
  },
};
</script>
<style scoped>
::v-deep .el-dialog .upload-demo {
  width: 100%;
}
</style>
